import api from '../api';

// Mock data functions at the top (following existing pattern)
const getMockRolesData = () => {
  return [
    {
      id: 1,
      name: 'admin',
      display_name: 'Administrator',
      description: 'Full system administrator with all permissions',
      level: 1,
      permissions: [
        { id: 1, name: 'list-users', display_name: 'List Users' },
        { id: 2, name: 'create-users', display_name: 'Create Users' },
        { id: 3, name: 'update-users', display_name: 'Update Users' },
        { id: 4, name: 'delete-users', display_name: 'Delete Users' },
        { id: 5, name: 'list-roles', display_name: 'List Roles' },
        { id: 6, name: 'update-roles', display_name: 'Update Roles' }
      ]
    },
    {
      id: 2,
      name: 'manager',
      display_name: 'Manager',
      description: 'Manager with limited permissions',
      level: 2,
      permissions: [
        { id: 1, name: 'list-users', display_name: 'List Users' },
        { id: 2, name: 'create-users', display_name: 'Create Users' },
        { id: 3, name: 'update-users', display_name: 'Update Users' }
      ]
    },
    {
      id: 3,
      name: 'user',
      display_name: 'User',
      description: 'Standard user with basic permissions',
      level: 3,
      permissions: [
        { id: 1, name: 'list-users', display_name: 'List Users' }
      ]
    }
  ];
};

const getMockPermissionsData = () => {
  return [
    { id: 1, name: 'list-users', display_name: 'List Users' },
    { id: 2, name: 'create-users', display_name: 'Create Users' },
    { id: 3, name: 'update-users', display_name: 'Update Users' },
    { id: 4, name: 'delete-users', display_name: 'Delete Users' },
    { id: 5, name: 'list-roles', display_name: 'List Roles' },
    { id: 6, name: 'update-roles', display_name: 'Update Roles' },
    { id: 7, name: 'list-permissions', display_name: 'List Permissions' },
    { id: 8, name: 'update-permissions', display_name: 'Update Permissions' },
    { id: 9, name: 'list-guardians', display_name: 'List Guardians' },
    { id: 10, name: 'create-guardians', display_name: 'Create Guardians' },
    { id: 11, name: 'update-guardians', display_name: 'Update Guardians' },
    { id: 12, name: 'delete-guardians', display_name: 'Delete Guardians' }
  ];
};

const rolesService = {
  // Get all roles
  getRoles: async () => {
    try {
      console.log("Fetching roles data");
      const response = await api.get('/roles');
      console.log("Roles response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching roles:", error);
      console.log("Falling back to mock data");
      return {
        success: true,
        data: getMockRolesData()
      };
    }
  },

  // Get role by ID
  getRoleById: async (id) => {
    try {
      console.log("Fetching role by ID:", id);
      const response = await api.get(`/roles/${id}/edit`);
      console.log("Role response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching role:", error);
      console.log("Falling back to mock data");
      const roles = getMockRolesData();
      const role = roles.find(r => r.id === parseInt(id));
      const permissions = getMockPermissionsData();
      
      if (role) {
        return {
          success: true,
          data: {
            role,
            permissions,
            rolePerms: role.permissions.map(p => p.id)
          }
        };
      } else {
        throw new Error('Role not found');
      }
    }
  },

  // Update role
  updateRole: async (id, data) => {
    try {
      console.log("Updating role:", id, data);
      const response = await api.put(`/roles/${id}`, data);
      console.log("Update response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating role:", error);
      console.log("Falling back to mock success");
      return {
        success: true,
        message: "Role successfully updated (mock)"
      };
    }
  },

  // Helper method to get mock data for testing
  getMockRolesData,
  getMockPermissionsData
};

export default rolesService;
